export default "__VITE_ASSET__Dn6EjREL__"